<template>
    <HeaderComponent/>
    <main class="pt-[70px] w-full h-screen bg-gray-100 relative flex">
        <SideBarComponent/>
        <div class="lg:w-[calc(100%-250px)] md:w-[calc(100%-78px)] lg:left-[250px] md:left-[78px] relative top-0 overflow-y-auto overflow-x-hidden h-full md:p-[25px] p-[20px]">
            <section class="w-full duration-500 relative flex flex-col flex-wrap items-center justify-between mb-[40px]">
                <div class="w-full bg-white rounded-lg shadow p-6 mb-6">
                    <h2 class="text-xl font-bold mb-4">Envoyer un email groupé</h2>
                    <form @submit.prevent="sendGroupEmail" class="space-y-4">
                        <div>
                            <label class="block text-sm font-medium text-gray-700">Destinataires</label>
                            <select v-model="selectedEmails" multiple class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-[#D4AF37] focus:ring-[#D4AF37]">
                                <option value="all">Tous les abonnés</option>
                                <option v-for="email in subscriptions" :key="email._id" :value="email.email">{{ email.email }}</option>
                            </select>
                        </div>
                        <div>
                            <label class="block text-sm font-medium text-gray-700">Sujet</label>
                            <input v-model="emailSubject" type="text" required class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-[#D4AF37] focus:ring-[#D4AF37]">
                        </div>
                        <div>
                            <label class="block text-sm font-medium text-gray-700">Contenu</label>
                            <textarea v-model="emailContent" required rows="5" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-[#D4AF37] focus:ring-[#D4AF37]"></textarea>
                        </div>
                        <button type="submit" class="px-4 py-2 bg-[#D4AF37] text-white rounded-md hover:bg-[#C9A227]">Envoyer</button>
                    </form>
                </div>

                <div class="w-full bg-white rounded-lg shadow p-6 mb-6">
                    <h2 class="text-xl font-bold mb-4">Liste des abonnés</h2>
                    <div class="overflow-x-auto">
                        <table class="min-w-full divide-y divide-gray-200">
                            <thead class="bg-gray-50">
                                <tr>
                                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Email</th>
                                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date d'inscription</th>
                                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                                </tr>
                            </thead>
                            <tbody class="bg-white divide-y divide-gray-200">
                                <tr v-for="sub in subscriptions" :key="sub._id">
                                    <td class="px-6 py-4 whitespace-nowrap">{{ sub.email }}</td>
                                    <td class="px-6 py-4 whitespace-nowrap">{{ new Date(sub.subscribedAt).toLocaleDateString() }}</td>
                                    <td class="px-6 py-4 whitespace-nowrap">
                                        <button @click="deleteEmail(sub._id)" class="text-red-600 hover:text-red-900">Supprimer</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="w-full bg-white rounded-lg shadow p-6">
                    <h2 class="text-xl font-bold mb-4">Messages reçus</h2>
                    <div class="overflow-x-auto">
                        <table class="min-w-full divide-y divide-gray-200">
                            <thead class="bg-gray-50">
                                <tr>
                                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Nom</th>
                                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Email</th>
                                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Téléphone</th>
                                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Message</th>
                                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date</th>
                                </tr>
                            </thead>
                            <tbody class="bg-white divide-y divide-gray-200">
                                <tr v-for="msg in messages" :key="msg._id">
                                    <td class="px-6 py-4 whitespace-nowrap">{{ msg.prenoms }} {{ msg.nom }}</td>
                                    <td class="px-6 py-4 whitespace-nowrap">{{ msg.email }}</td>
                                    <td class="px-6 py-4 whitespace-nowrap">{{ msg.phone }}</td>
                                    <td class="px-6 py-4">{{ msg.message }}</td>
                                    <td class="px-6 py-4 whitespace-nowrap">{{ new Date(msg.sentAt).toLocaleDateString() }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>
        </div>
    </main>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import HeaderComponent from '@/components/HeaderComponentAdmin.vue'
import SideBarComponent from '@/components/SideBarComponent.vue'
import apiClient from '@/services/api';
import { toast } from 'vue3-toastify'

const subscriptions = ref([]);
const messages = ref([]);
const selectedEmails = ref(['all']);
const emailSubject = ref('');
const emailContent = ref('');

const fetchSubscriptions = async () => {
    try {
        const response = await apiClient.get('/subscriptions/list');
        subscriptions.value = await response.data;
    } catch (error) {
        console.error('Error fetching subscriptions:', error);
    }
};

const fetchMessages = async () => {
    try {
        const response = await apiClient.get('/messages/list');
        messages.value = await response.data;
    } catch (error) {
        console.error('Error fetching messages:', error);
    }
};

const deleteEmail = async (id) => {
    if (confirm('Êtes-vous sûr de vouloir supprimer cet email ?')) {
        try {
            await apiClient.delete(`/subscriptions/${id}`);
            fetchSubscriptions();
        } catch (error) {
            console.error('Error deleting email:', error);
        }
    }
};

const sendGroupEmail = async () => {
    try {
        await apiClient.post('/subscriptions/send', {
            subject: emailSubject.value,
            content: emailContent.value,
            emails: selectedEmails.value.includes('all') ? [] : selectedEmails.value
        });

        toast.success('Email envoyé avec succès !', { position: 'top-right', autoClose: 3000 });
        emailSubject.value = '';
        emailContent.value = '';
        selectedEmails.value = ['all'];
    } catch (error) {
        console.error('Error sending group email:', error);
        toast.error('Erreur lors de l\'envoi de l\'email', { position: 'top-right', autoClose: 4000 });
    }
};

onMounted(() => {
    fetchSubscriptions();
    fetchMessages();
});
</script>

<style>
/* Vous pouvez ajouter des styles personnalisés ici si nécessaire */
</style>
